export default __webpack_public_path__ + "static/netlify-130c0fb31f2eab23208532fac8480830.svg";